// import { useState } from 'react';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     message: ''
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert('Form submitted! (You can connect EmailJS later)');
//     // You can add EmailJS or backend API call here
//   };

//   return (
//     <section id="contact" style={{ padding: '80px 20px', backgroundColor: '#f9f9f9' }}>
//       <h2 data-aos="fade-up" style={{ textAlign: 'center', marginBottom: '40px' }}>
//         Get in Touch
//       </h2>
//       <form
//         data-aos="fade-up"
//         onSubmit={handleSubmit}
//         style={{
//           maxWidth: '600px',
//           margin: '0 auto',
//           display: 'flex',
//           flexDirection: 'column',
//           gap: '20px',
//           backgroundColor: '#fff',
//           padding: '40px',
//           borderRadius: '12px',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
//         }}
//       >
//         <input
//           type="text"
//           name="name"
//           placeholder="Your Name"
//           required
//           onChange={handleChange}
//           style={inputStyle}
//         />
//         <input
//           type="email"
//           name="email"
//           placeholder="Your Email"
//           required
//           onChange={handleChange}
//           style={inputStyle}
//         />
//         <textarea
//           name="message"
//           rows="5"
//           placeholder="Your Message"
//           required
//           onChange={handleChange}
//           style={inputStyle}
//         />
//         <button
//           type="submit"
//           style={{
//             padding: '12px 20px',
//             backgroundColor: '#DC4225',
//             color: '#fff',
//             fontWeight: 'bold',
//             border: 'none',
//             borderRadius: '8px',
//             cursor: 'pointer'
//           }}
//         >
//           Send Message
//         </button>
//       </form>
//     </section>
//   );
// };

// const inputStyle = {
//   padding: '12px 15px',
//   borderRadius: '8px',
//   border: '1px solid #ccc',
//   fontSize: '1rem'
// };

// export default Contact;

// import React from 'react';
// import Footer from '../components/Footer';
// const Contact = () => {
//   return (
//     <section id="contact" style={styles.section}>
//       <h2 style={styles.heading}>Get in Touch</h2>
//       <p style={styles.subheading}>We’d love to hear from you — whether it's a question or a quote request!</p>

//       <form style={styles.form}>
//         <input type="text" name="name" placeholder="Your Name" required style={styles.input} />
//         <input type="email" name="email" placeholder="Your Email" required style={styles.input} />
//         <textarea name="message" placeholder="Your Message" rows="5" required style={styles.textarea}></textarea>
//         <button type="submit" style={styles.button}>Send Message</button>
//       </form>
      
//     </section>
    
    
//   );
//   <Footer/>
// };

// const styles = {
//   section: {
//     padding: '80px 10% 60px',
//     backgroundColor: '#f8f8f8',
//     textAlign: 'center',
//     marginTop:"40px",
//   },
//   heading: {
//     fontSize: '2.2rem',
//     marginBottom: '10px',
//     color: '#DC4225',
//   },
//   subheading: {
//     fontSize: '1rem',
//     marginBottom: '30px',
//     color: '#555',
//   },
//   form: {
//     maxWidth: '600px',
//     margin: '0 auto',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '20px',
//   },
//   input: {
//     padding: '12px 15px',
//     borderRadius: '8px',
//     border: '1px solid #ccc',
//     fontSize: '1rem',
//   },
//   textarea: {
//     padding: '12px 15px',
//     borderRadius: '8px',
//     border: '1px solid #ccc',
//     fontSize: '1rem',
//   },
//   button: {
//     padding: '12px 20px',
//     border: 'none',
//     borderRadius: '8px',
//     backgroundColor: '#DC4225',
//     color: '#fff',
//     fontSize: '1rem',
//     cursor: 'pointer',
//     transition: 'background 0.3s',
//   },
// };


// export default Contact;


// import React, { useState } from 'react';

// export default function Contact() {
//   const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Basic validation
//     if (!form.name || !form.email || !form.message) {
//       alert('Please fill out all required fields');
//       return;
//     }

//     // 🟡 You can later send this to Google Sheets or Email
//     console.log('Form submitted:', form);
//     alert('Thank you! We received your message.');

//     // Reset form
//     setForm({ name: '', email: '', phone: '', message: '' });
//   };

//   return (
//     <div style={{ maxWidth: '600px', margin: '50px auto', padding: '100px', background: '#fff', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
//       <h2 style={{ marginBottom: '20px', color: '' }}>Contact Us</h2>
//       <form onSubmit={handleSubmit}>
//         <input type="text" name="name" placeholder="Your Name" value={form.name} onChange={handleChange} required style={inputStyle} />
//         <input type="email" name="email" placeholder="Your Email" value={form.email} onChange={handleChange} required style={inputStyle} />
//         <input type="tel" name="phone" placeholder="Your Phone (optional)" value={form.phone} onChange={handleChange} style={inputStyle} />
//         <textarea name="message" placeholder="Your Message" value={form.message} onChange={handleChange} required style={{ ...inputStyle, height: '100px' }}></textarea>
//          <button class="button type1">
//          </button>
//       </form>
//     </div>
//   );
// }

// const inputStyle = {
//   width: '100%',
//   padding: '10px',
//   marginBottom: '15px',
//   border: '1px solid #ccc',
//   borderRadius: '5px',
//   fontSize: '16px'
// };


// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// export default function Contact() {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//     botField: '', // honeypot field
//   });

//   const [submitting, setSubmitting] = useState(false);

//   // ...handleChange and encode functions unchanged...

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!form.name || !form.email || !form.message) {
//       alert('Please fill out all required fields');
//       return;
//     }

//     if (form.botField) {
//       return; // likely spam
//     }

//     setSubmitting(true);

//     fetch('/', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//       body: encode({
//         'form-name': 'contact',
//         ...form,
//       }),
//     })
//       .then(() => {
//         alert('Thank you! We received your message.');
//         setForm({
//           name: '',
//           email: '',
//           phone: '',
//           message: '',
//           botField: '',
//         });
//         setSubmitting(false);
//         navigate('/thankyou'); // Redirect here
//       })
//       .catch(() => {
//         alert('Oops! There was a problem submitting your form');
//         setSubmitting(false);
//       });
//   };





// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';


// export default function Contact() {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//     botField: '', // honeypot field (should remain empty)
//   });

//   const [submitting, setSubmitting] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // Netlify form encode helper
//   const encode = (data) => {
//     return Object.keys(data)
//       .map(
//         (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
//       )
//       .join('&');
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Basic validation
//     if (!form.name || !form.email || !form.message) {
//       alert('Please fill out all required fields');
//       return;
//     }

//     // Honeypot spam check
//     if (form.botField) {
//         return; // likely spam, do nothing
//       }
  
//       setSubmitting(true);

//     fetch('/', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//       body: encode({
//         'form-name': 'contact',
//         ...form,
//       }),
//     })
//      .then(() => {
//   alert('Thank you! We received your message.');
//   setForm({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//     botField: '',
//   });
//   setSubmitting(false);
//   navigate('/thankyou'); // yahan redirect karo
// })

//       .catch((error) => {
//         alert('Oops! There was a problem submitting your form');
//         setSubmitting(false);
//       });
//   };


//   return (
//     <div className="contact-container" style={{ maxWidth: 600, margin: '50px auto', padding: 40, background: '#fff', borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.1)' ,paddingTop:"70px"}}>
//       <h2 style={{ marginBottom: 20, color: '#008080', textAlign: 'center' }}>Contact Us</h2>
//       <form
//         name="contact"
//         method="POST"
//         data-netlify="true"
//         data-netlify-honeypot="botField"
//         onSubmit={handleSubmit}
//         className="contact-form"
//       >
//         {/* Honeypot field - hide from users */}
//         <input
//           type="hidden"
//           name="form-name"
//           value="contact"
//         />
//         <input
//           type="text"
//           name="botField"
//           value={form.botField}
//           onChange={handleChange}
//           style={{ display: 'none' }}
//           tabIndex="-1"
//           autoComplete="off"
//         />

//         <input
//           type="text"
//           name="name"
//           placeholder="Your Name"
//           value={form.name}
//           onChange={handleChange}
//           required
//           style={inputStyle}
//         />
//         <input
//           type="email"
//           name="email"
//           placeholder="Your Email"
//           value={form.email}
//           onChange={handleChange}
//           required
//           style={inputStyle}
//         />
//         <input
//           type="tel"
//           name="phone"
//           placeholder="Your Phone (optional)"
//           value={form.phone}
//           onChange={handleChange}
//           style={inputStyle}
//         />
//         <textarea
//           name="message"
//           placeholder="Your Message"
//           value={form.message}
//           onChange={handleChange}
//           required
//           style={{ ...inputStyle, height: 100 }}
//         ></textarea>

//         {/* reCAPTCHA widget */}
//         <div className="g-recaptcha" data-sitekey="YOUR_RECAPTCHA_SITE_KEY" style={{ marginBottom: '15px' }}></div>

//         <button
//           type="submit"
//           disabled={submitting}
//           style={{
//             backgroundColor: '#008080',
//             color: '#fff',
//             padding: '12px',
//             border: 'none',
//             borderRadius: '6px',
//             cursor: 'pointer',
//             fontSize: '1rem',
//             transition: 'background-color 0.3s ease',
//             opacity: submitting ? 0.6 : 1,
//           }}
//         >
//           {submitting ? 'Sending...' : 'Send Message'}
//         </button>
//       </form>

//       {/* Add this script tag in your public/index.html or use react-helmet to load it */}
//       {/* <script src="https://www.google.com/recaptcha/api.js" async defer></script> */}
//     </div>
//   );
// }

// const inputStyle = {
//   width: '100%',
//   padding: '10px',
//   marginBottom: '15px',
//   border: '1px solid #ccc',
//   borderRadius: '5px',
//   fontSize: '16px',
// };

// url api key.........

// https://recaptchaenterprise.googleapis.com/v1/projects/jas-contracts/assessments?key=API_KEY


// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// export default function Contact() {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//     botField: '',
//   });

//   const [submitting, setSubmitting] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   /* global grecaptcha */

//   // Netlify form encode helper
//   const encode = (data) => {
//     return Object.keys(data)
//       .map(
//         (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
//       )
//       .join('&');
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!form.name || !form.email || !form.message) {
//       alert('Please fill out all required fields');
//       return;
//     }

//     if (form.botField) return; // spam honeypot

//     setSubmitting(true);

//     // ✅ Run reCAPTCHA before sending form
//     grecaptcha.enterprise.ready(async () => {
//       try {
//         const token = await grecaptcha.enterprise.execute(
//           '6LcxV6IrAAAAAKSpvNvjw9zP1gg02wFCxVaDV1hG', // your site key
//           { action: 'submit' }
//         );

//         fetch('https://recaptchaenterprise.googleapis.com/v1/projects/jas-contracts/assessments?key=API_KEY', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//           body: encode({
//             'form-name': 'contact',
//             ...form,
//             'g-recaptcha-response': token,
//           }),
//         })
//           .then(() => {
//             navigate('/thankyou');
//             setSubmitting(false);
//           })
//           .catch((error) => {
//             alert('Oops! There was a problem submitting your form');
//             setSubmitting(false);
//           });
//       } catch (err) {
//         console.error('reCAPTCHA error', err);
//         alert('reCAPTCHA failed. Please try again.');
//         setSubmitting(false);
//       }
//     });
//   };

//   return (
//     <div
//       className="contact-container"
//       style={{
//         maxWidth: 600,
//         margin: '50px auto',
//         padding: 40,
//         background: '#fff',
//         borderRadius: 10,
//         boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//         paddingTop: '70px',
//       }}
//     >
//       <h2 style={{ marginBottom: 20, color: '#008080', textAlign: 'center' }}>
//         Contact Us
//       </h2>

//       <form
//         name="contact"
//         method="POST"
//         data-netlify="true"
//         data-netlify-honeypot="botField"
//         onSubmit={handleSubmit}
//         className="contact-form"
//       >
//         <input type="hidden" name="form-name" value="contact" />
//         <input
//           type="text"
//           name="botField"
//           value={form.botField}
//           onChange={handleChange}
//           style={{ display: 'none' }}
//           tabIndex="-1"
//           autoComplete="off"
//         />

//         <input
//           type="text"
//           name="name"
//           placeholder="Your Name"
//           value={form.name}
//           onChange={handleChange}
//           required
//           style={inputStyle}
//         />
//         <input
//           type="email"
//           name="email"
//           placeholder="Your Email"
//           value={form.email}
//           onChange={handleChange}
//           required
//           style={inputStyle}
//         />
//         <input
//           type="tel"
//           name="phone"
//           placeholder="Your Phone (optional)"
//           value={form.phone}
//           onChange={handleChange}
//           style={inputStyle}
//         />
//         <textarea
//           name="message"
//           placeholder="Your Message"
//           value={form.message}
//           onChange={handleChange}
//           required
//           style={{ ...inputStyle, height: 100 }}
//         ></textarea>

//         <button
//           type="submit"
//           disabled={submitting}
//           style={{
//             backgroundColor: '#008080',
//             color: '#fff',
//             padding: '12px',
//             border: 'none',
//             borderRadius: '6px',
//             cursor: 'pointer',
//             fontSize: '1rem',
//             transition: 'background-color 0.3s ease',
//             opacity: submitting ? 0.6 : 1,
//           }}
//         >
//           {submitting ? 'Sending...' : 'Send Message'}
//         </button>
//       </form>
//     </div>
//   );
// }

// const inputStyle = {
//   width: '100%',
//   padding: '10px',
//   marginBottom: '15px',
//   border: '1px solid #ccc',
//   borderRadius: '5px',
//   fontSize: '16px',
// };



import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

// optional: set to true to redirect after success
const REDIRECT_AFTER_SUCCESS = true;
// const THANKYOU_PATH = "/thankyou";

// ====== CONFIGURE THESE ======
const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwacg-MQA2DMnDJBDKknRr2PzNJ2S9DxabD0bQ8TtOiWRBMsxFpkgQBLK7WRdEqLKKzZw/exec"; // <- paste from Apps Script deploy
const RECAPTCHA_SITE_KEY = "6LcV8aQrAAAAAO6-NF-gMzmd934lYUcG0HP8ZjoP"; // <- your reCAPTCHA v3 site key
// =============================

const ContactForm = () => {
  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    projectDetails: "",
    botField: "" // honeypot
  });

  const inputStyle = {
    padding: "10px",
    margin: "8px 0",
    border: "1px solid #004d4d",
    borderRadius: "6px",
    fontSize: "1rem",
    width: "100%"
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  // helper to URL-encode (avoids CORS preflight)
  const encode = (data) =>
    Object.keys(data)
      .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(data[k] ?? ""))
      .join("&");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.botField) return; // spam

    if (!form.name || !form.email || !form.projectDetails) {
      alert("Please fill all required fields.");
      return;
    }

    try {
      setSubmitting(true);

      // 1) get reCAPTCHA v3 token
      const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "submit" });

      // 2) send to Apps Script (URL-encoded)
      const body = encode({
        name: form.name,
        email: form.email,
        phone: form.phone,
        service: form.service,
        projectDetails: form.projectDetails,
        "g-recaptcha-response": token // name expected by siteverify
      });

      const res = await fetch(APPS_SCRIPT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body
      });

      const json = await res.json();
      if (json.result === "success") {
        if (REDIRECT_AFTER_SUCCESS) {
          // window.location.href = THANKYOU_PATH;
            navigate('/thankyou');

        } else {
          alert("Message sent successfully!");
        }
        setForm({
          name: "",
          email: "",
          phone: "",
          service: "",
          projectDetails: "",
          botField: ""
        });
      } else {
        alert(json.message || "Something went wrong. Please try again.");
      }
    } catch (err) {
      alert("Failed to submit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <h1 className="contactform-h1">Contact Us</h1>
    <form
      name="contact"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="botField"
      onSubmit={handleSubmit}
      className="contact-form"
    >
      
      <input type="hidden" name="form-name" value="contact" />
      <input
        type="text"
        name="botField"
        value={form.botField}
        onChange={handleChange}
        style={{ display: "none" }}
        tabIndex="-1"
        autoComplete="off"
      />

      <input
        type="text"
        name="name"
        placeholder="Your Name"
        value={form.name}
        onChange={handleChange}
        required
        style={inputStyle}
      />
      <input
        type="email"
        name="email"
        placeholder="Your Email"
        value={form.email}
        onChange={handleChange}
        required
        style={inputStyle}
      />
      <input
        type="tel"
        name="phone"
        placeholder="Your Phone (optional)"
        value={form.phone}
        onChange={handleChange}
        style={inputStyle}
      />
      <input
        type="text"
        name="service"
        placeholder="Service (e.g. Painting, Industrial Coating)"
        value={form.service}
        onChange={handleChange}
        style={inputStyle}
      />
      <textarea
        name="projectDetails"
        placeholder="Project Details"
        value={form.projectDetails}
        onChange={handleChange}
        required
        style={{ ...inputStyle, height: 100 }}
      />

      <button
        type="submit"
        disabled={submitting}
        style={{
          // backgroundColor: "#008080",
          // color: "#fff",
          // padding: "12px",
          // border: "none",
          // borderRadius: "6px",
          // cursor: "pointer",
          // fontSize: "1rem",
          transition: "background-color 0.3s ease",
          opacity: submitting ? 0.6 : 1
        }}
      >
        {submitting ? "Sending..." : "Send Message"}
      </button>
    </form>
    </>
  );
};

export default ContactForm;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";  // ✅ add this

// const ContactForm = () => {
//   const navigate = useNavigate();   // ✅ initialize navigate
//   const [submitting, setSubmitting] = useState(false);
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     service: "",
//     projectDetails: "",
//     botField: ""
//   });

//   const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbw9L6Vj9ADNklvz8-Pr7IvuOupgg_aC4oYoUDCEb9-vt_Zipke4rN82UB0vs-ZcA73F/exec";
//   const RECAPTCHA_SITE_KEY = "6LcV8aQrAAAAAO6-NF-gMzmd934lYUcG0HP8ZjoP";

//   const inputStyle = {
//     padding: "10px",
//     margin: "8px 0",
//     border: "1px solid #004d4d",
//     borderRadius: "6px",
//     fontSize: "1rem",
//     width: "100%"
//   };

//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//   const encode = (data) =>
//     Object.keys(data)
//       .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k] ?? ""))
//       .join("&");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (form.botField) return;

//     try {
//       setSubmitting(true);

//       const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "submit" });

//       const body = encode({
//         ...form,
//         "g-recaptcha-response": token
//       });

//       const res = await fetch(APPS_SCRIPT_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body
//       });

//       const json = await res.json();
//       if (json.result === "success") {
//         // ✅ Use React Router navigation instead of window.location
//         navigate("/thankyou");

//         setForm({
//           name: "",
//           email: "",
//           phone: "",
//           service: "",
//           projectDetails: "",
//           botField: ""
//         });
//       } else {
//         alert(json.message || "Something went wrong. Please try again.");
//       }
//     } catch (err) {
//       alert("Failed to submit. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <>
//     <form onSubmit={handleSubmit} className="contact-form" style={{paddingTop:"100px"}}>
//       <input type="text" name="name" placeholder="Your Name" value={form.name} onChange={handleChange} required style={inputStyle} />
//       <input type="email" name="email" placeholder="Your Email" value={form.email} onChange={handleChange} required style={inputStyle} />
//       <input type="tel" name="phone" placeholder="Your Phone (optional)" value={form.phone} onChange={handleChange} style={inputStyle} />
//       <input type="text" name="service" placeholder="Service" value={form.service} onChange={handleChange} style={inputStyle} />
//       <textarea name="projectDetails" placeholder="Project Details" value={form.projectDetails} onChange={handleChange} required style={{ ...inputStyle, height: 100 }} />
//       <button type="submit" disabled={submitting}  style={{
//           backgroundColor: "#008080",
//           color: "#fff",
//           padding: "12px",
//           border: "none",
//           borderRadius: "6px",
//           cursor: "pointer",
//           fontSize: "1rem",
//           transition: "background-color 0.3s ease",
//           opacity: submitting ? 0.6 : 1
//         }}>
//         {submitting ? "Sending..." : "Send Message"}
//       </button>
//     </form>
//     </>
//   );
// };

// export default ContactForm;
